import App from "../../App";

const Notifications = {

    reset: 0,

    init() {

        this.el = $('[component="Notifications"]');
        this.button = this.el.find('button.hide');

        this.bind();
    },

    bind() {

        this.el.on("click", "button.hide", (event) => {
            let notification = $(event.currentTarget).parents().closest('[component="Notifications"] [element="Notification"]');

            $(notification).hide(0);
            /*$(notification).fadeOut(1000, () => {
                $(notification).remove();
            });*/

            return false;
        });
    },

    update_(data) {

        if (!data.update) {
            return;
        }

        $.each(data.update, function (i, e) {

            if ($.isPlainObject(e)) {

                if (e.notification) {

                    /*if ( i )
                        $( i ).append( e.html );
                    else
                        */
                    Notifications.el.append(e.html);
                    setTimeout(() => {
                        Notifications.el.children().addClass("active");
                    },500);

                    //debug( e );
                    Notifications.show_status(e.notification, e.stime);
                }

                /*if ( e.highlight ) {
                    $( i ).removeClass( 'highlightRED highlightGREEN pulse01_once' );

                    if ( $( i ).text() > e.data ) {
                        $( i ).addClass( 'highlightRED pulse01_once' );
                    } else if ( $( i ).text() < e.data )
                        $( i ).addClass( 'highlightGREEN pulse01_once' );
                }*/

                if (e.data) {
                    $(i).html(e.data);
                }

                if (e.value || e.value === 0) {
                    $(i).val(e.value);
                }

                if (e.style) {
                    //var $CSS = e.style;

                    $.each(e.style, function (ii, ee) {
                        //	console.log( ii );
                        $(i).css(ii, ee);
                    });
                    //$( i ).css({ $CSS });
                }

                if (e.show) {
                    $(i).show(0);
                }

                if (e.fadeIn)
                    $(e.fadeIn[0]).fadeIn(e.fadeIn[1]);

                if (e.hide) {
                    $(i).hide(0);
                }

                if (e.removeClass) {
                    $(i).removeClass(e.removeClass);
                }

                if (e.removeAttr) {
                    $(i).removeAttr(e.removeAttr);
                }

                if (e.class) {
                    $(i).removeClass(e.class).addClass(e.class);
                }

                if (e.trigger) {
                    setTimeout(function () {
                        $(e.trigger[0]).trigger(e.trigger[1]);
                    }, 1000);
                }

            } else {

                /*if ( e.trigger ) {
                    setTimeout(function () {
                        $( e.trigger[0] ).trigger( e.trigger[1] );
                    }, 1000);
                } else {*/
                $(i).html(e);
                //}
            }
        })
    },

    show_status($id, $time = null) {

        let hidetime = $time ? $time : $('#' + $id).data('stime') ? $('#' + $id).data('stime') : 10000;

        this.hide_status($('#' + $id), hidetime);
    },

    hide_status($target, hidetime) {

        this.progress_status($target, hidetime);

//		clearTimeout(reset2);

        this.reset = setTimeout(function () {
            $target.addClass("hidden");

            setTimeout(() => {
                $target.remove();
            },1000);

        }, hidetime);
    },

    progress_status($target, hidetime) {

        let width = $($target).find('.pstatus-progress').width(),
            re = ((0 / width) * 100);

        $($target).find('.pstatus-progress div').stop(0).animate({
            width: re + '%'
        }, hidetime);
    }
}
export default Notifications;